import { isAfter, startOfMonth } from 'date-fns';
import { getPaymentMethodIcons } from '../../shared/getBrandIcon';
import { CreditCardInfo } from '../../store/client/client.types';

export const formatExpireDate = (expMonth: number | null, expYear: number | null) => {
  if (!expMonth || !expYear) return '';

  const formatExpMonth = expMonth < 10 ? `0${expMonth}` : expMonth;

  return `${formatExpMonth}/${expYear}`;
};

export const isCreditCardExpired = (expMonth: number | null, expYear: number | null) => {
  if (!expMonth || !expYear) return false;

  const currentDate = new Date();

  const cardExpirationDate = startOfMonth(new Date(expYear, expMonth));

  return isAfter(currentDate, cardExpirationDate);
};

export const getFormattedCardDetail = (cardData: CreditCardInfo) => {
  const { brand, walletType, label, exp_year, exp_month, isDefault, isValid } = cardData;

  const icons = getPaymentMethodIcons({ brand, walletType });
  const expiredDate = formatExpireDate(exp_month, exp_year);
  const creditCardExpired = isCreditCardExpired(exp_month, exp_year);

  return { icons, expiredDate, creditCardExpired, isDefault, isValid, label };
};
